// 计算lb 和cft 的计算方法 及公式

// 详细中单位转换的计算规则 挂载在计算方法中
export const byBoxs = {
  computed: {
    sumCBM() {
      let num = 0;
      this.radCargo.forEach((e) => {
        if(this.volumeUnit == 0) {
          num +=
            ((Number(e.length) * Number(e.width) * Number(e.height)) / 1000000) *
            Number(e.quanlity); 
        } else {
          num +=
            Number(e.length) *
            Number(e.width) *
            Number(e.height) *
            Number(e.quanlity) *
            0.000016387064;
        }
      });
      return Number(num) || 0
    },
    sumCFT() {
      let num = 0;
      this.radCargo.forEach((e) => {
        if(this.volumeUnit == 0) {
          num +=
            ((Number(e.length) * Number(e.width) * Number(e.height)) / 1000000) *
            Number(e.quanlity) *
            35.3147248;
        } else {
          num +=
            Number(e.length) *
            Number(e.width) *
            Number(e.height) *
            0.000016387064 *
            35.3147248 *
            e.quanlity;
        }
      });
      return Number(num) || 0
    },
    sumUnit() {
      let num = 0;
      this.radCargo.forEach((e) => {
        num += Number(e.quanlity);
      });
      return Number(num) || 0
    },
    sumKG() {
      let num = 0;
      this.radCargo.forEach((e) => {
        if (this.volumeUnit == 0) {
          num += Number(e.quanlity) * Number(e.weight);
        } else {
          num += Number(e.quanlity) * (Number(e.weight) * 0.4535924);
        }
      });
      return Number(num) || 0
    },
    sumLB() {
      let num = 0;
      this.radCargo.forEach((e) => {
        if (this.volumeUnit == 0) { 
          num += Number(e.quanlity) * (Number(e.weight) * 2.2046226);
        } else {
          num += Number(e.quanlity) * Number(e.weight);
        }
      });
      return Number(num) || 0
    },
  },
}

// 总计中单位转换的计算规则 挂载在计算方法中
export const byTotal = {
  computed: {
    sumCBM() {
      if(this.volumeUnit == 0) {
        return Number(this.totalInfo.volume) || 0
      } else {
        return this.totalInfo.volume * 0.0283168 
      }
    },
    sumCFT() {
      if(this.volumeUnit == 0) {
        return this.totalInfo.volume * 35.3147248
      } else {
        return Number(this.totalInfo.volume)
      }
    },
    sumUnit() {
      return Number(this.totalInfo.unit) 
    },
    sumKG() {
      if(this.volumeUnit == 0) {
        return Number(this.totalInfo.weight) || 0
      } else {
        return this.totalInfo.weight * 0.4535924 
      }
    },
    sumLB() {
      if(this.volumeUnit == 0) {
        return this.totalInfo.weight * 2.2046226
      } else {
        return Number(this.totalInfo.weight)
      }
    },
  },
}


// WEBPACK FOOTER //
// ./src/utils/transfromUnit.js